import styled from "styled-components";
import {theme} from "../../../configuration";

const HeaderMenu = styled.div`
  font-family: ${theme.fonts.main};
  font-size: ${theme.sizes.main};
  height: 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 4px;
`;

export default HeaderMenu;